<template>
	<wt-selector class="agent-selector" ref="select" :multiple="multiple" :options="options" v-model="Value" clearable="true" v-bind="$attrs" :disabled="disabled" @change="change"></wt-selector>
</template>
<script>
export default {
  name: 'agent-selector',
  props: {
    value: {
      type: [Array, String]
    },
    // 筛选的组织类型
    organizationType: {
      type: [Array, String],
      default: () => ['DISTRIBUTION', 'AGENT']
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    change (val) {
      this.$emit('change', val)
    },
    getAnalysis () {
      this.$store.dispatch('getOrganizations').then(data => {
        // console.log('getSampleType-------ss-s-s',response.data)
        let options = []
        data.forEach(item => {
          // 将字符串转化为数组
          let organizationType = this.organizationType
          /* global _ */
          if (_.isString(this.organizationType)) {
            organizationType = [this.organizationType]
          }
          // 判断是否有交集
          if (organizationType.filter(v => item.roles.includes(v)).length) {
            let signalItem = {
              label: item.fullName || item.name,
              value: item.id,
              addresses: item.addresses
            }
            options.push(signalItem)
          }
        })
        this.options = options
        this.$emit('getOrgs', options)
      })
    }
  },
  created () {
    this.getAnalysis()
  }
}
</script>
<style lang="less">
.agent-selector{
      .el-input,.el-input__inner{
        height: .4rem !important;
      }
}
</style>
